"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = installStatusModalReducer;

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

function installStatusModalReducer(installStatusModal, action) {
  switch (action.type) {
    case _ActionTypes.default.DISMISSED_INSTALL_STATUS_MODAL:
      return installStatusModal.merge({
        goodId: '',
        open: false
      });

    case _ActionTypes.default.OPEN_SLOW_DELIVERY_MODAL:
      return installStatusModal.merge({
        goodId: action.payload.goodId,
        open: true
      });

    default:
      return installStatusModal;
  }
}

module.exports = exports.default;